import $ from 'jquery';
import { emitter } from './emitter';
/**
 * featured-people
 *
 * @module featured-people
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-11 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-11-30 using ChatGPT
 */

class FeaturedPeople {
  constructor(element) {
    this.$el = $(element);

    this.setupBinds();
    // Log removed: 'FeaturedPeople : Initialized'
  }

  setupBinds() {
    this.$featuredPeople = this.$el;
    emitter.on('updateFilter', this.listenForFilter.bind(this));
  }

  listenForFilter() {
    this.$featuredPeople.hide();
  }
}

export default FeaturedPeople;
